import { render, staticRenderFns } from "./plataccount.vue?vue&type=template&id=567b0637&"
import script from "./plataccount.vue?vue&type=script&lang=js&"
export * from "./plataccount.vue?vue&type=script&lang=js&"
import style0 from "./plataccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports